import React, { useState, useCallback, useMemo, useContext } from 'react';
import moment from 'moment';
import { SORT_BY_STRING } from '@ubeya/shared/utils/sorting';
import { API_TIME_FORMAT } from '@ubeya/shared/constants';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import ConfigContext from '../../../contexts/ConfigContext';

const ProjectLiveViewEndTimeFilter = ({
  slug,
  defaultValue,
  handleClose,
  onApply,
  search,
  onChange,
  externalOptions = {},
  hideLayout = false
}) => {
  const { t, timeFormat } = useContext(ConfigContext);
  const [values, setValues] = useState(defaultValue || []);

  const endTimeOptions = (externalOptions[slug] || [])
    .map(({ id, value }) => ({
      value: id,
      label: moment(value, API_TIME_FORMAT).format(timeFormat)
    }))
    .sort(SORT_BY_STRING('label'));

  const handleChange = useCallback(
    (value) => {
      const newValues = values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
      setValues(newValues);
      onChange?.(newValues);
    },
    [onChange, values]
  );

  const filteredOptions = useMemo(
    () =>
      search
        ? (endTimeOptions || []).filter(
            ({ label }) =>
              t('endTime').toLowerCase().includes(search.toLowerCase()) ||
              label.toLowerCase().includes(search.toLowerCase())
          )
        : endTimeOptions,
    [endTimeOptions, search, t]
  );

  if (!filteredOptions.length) {
    return null;
  }

  return (
    <FilterLayout name={t('endTime')} handleClose={handleClose} onApply={() => onApply(values)} hideLayout={hideLayout}>
      {filteredOptions.map(({ value, label }) => (
        <DropDown.Item key={value}>
          <CheckBox
            name={`endTime-${value}`}
            value={values.includes(value)}
            label={label}
            onChange={() => handleChange(value)}
          />
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default ProjectLiveViewEndTimeFilter;
